import api from '../../config/http-common';
import CommonUtil from "../../Util/CommonUtils";

const buildQuery = (payload) => {
  let query = "?pageNumber=" + payload.pageNumber + "&pageSize=" + payload.pageSize;

  if (!CommonUtil.isEmptyString(payload.type)) {
    query = query + "&type=" + payload.type;
  }
  return query;
}

const createEmailReport = (payload) => {
  return api.securedAxios().post('/web/email/report', payload)
}

const getEmailReportList = (payload) => {
  return api.securedAxios().get('/web/email/reports/lists' + buildQuery(payload))
}

const updateEmailReportById = (payload) => {
  return api.securedAxios().put('/web/email/report/' + payload.id, payload)
}

const deleteEmailReportById = (payload) => {
  return api.securedAxios().delete('/web/email/report/' + payload?.emailReportId +"?mode="+payload?.operationFrequency+"&operationLogEmailids="+payload?.operationLogEmailids+"&reportType="+payload?.reportType)
}

const addProduct = (payload) => {
  return api.securedAxios().post("/web/product/warehouse/email", payload);
}

const listOfProducts = (payload) => {
  return api.securedAxios().get("/web/product/warehouse/email/list" + buildQuery(payload));
}

const updateProducts = (payload) => {
  return api.securedAxios().put("/web/product/warehouse/email/" + payload.id, payload);
}

const resendProductEamil = (payload) => {
  return api.securedAxios().put("/web/product/warehouse/email/resend/" + payload.id+"?wareHouseEmail="+payload.wareHouseEmail);
}

const EmailReportService = {
  createEmailReport,
  getEmailReportList,
  updateEmailReportById,
  deleteEmailReportById,
  addProduct,
  listOfProducts,
  updateProducts,
  resendProductEamil,
}

export default EmailReportService